import { render, staticRenderFns } from "./TextInputField.vue?vue&type=template&id=6a8c2494&"
import script from "./TextInputField.vue?vue&type=script&lang=js&"
export * from "./TextInputField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextField,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a8c2494')) {
      api.createRecord('6a8c2494', component.options)
    } else {
      api.reload('6a8c2494', component.options)
    }
    module.hot.accept("./TextInputField.vue?vue&type=template&id=6a8c2494&", function () {
      api.rerender('6a8c2494', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/components/TextInputField.vue"
export default component.exports